<div class="container-fluid my-4">
    <vb-home-banner [banners]="banners"></vb-home-banner>
</div>

<div class="container-fluid mt-4">
    <vb-search
        placeholder="Search for lots, categories…"
        ariaLabel="Search for lots and categories" />
</div>

<div class="container-fluid mt-32px">
    <div *ngIf="isLoading" class="vb-spinner-box vb-spinner-box--page">
        <vb-spinner size="xl" label="Loading auctions"></vb-spinner>
    </div>
    <div *ngIf="!isLoading">
        <!-- Unable to Load -->
        <div *ngIf="unableToLoad" class="d-flex h-100 min-height-30">
            <h2 class="m-auto">Unable to load auctions</h2>
        </div>
        <!-- if no items  -->
        <div
            *ngIf="!unableToLoad && !featuredAuctions?.length"
            class="cartmini__empty text-center min-height-30">
            <img
                src="/assets/img/product/cartmini/empty-cart.png"
                alt="empty-cart-img" />
            <h4>No Auctions available!</h4>
        </div>
        <!-- Items -->
        <div *ngIf="featuredAuctions && !unableToLoad">
            <vb-carousel-auction
                *ngFor="let featuredAuction of featuredAuctions"
                [auction]="featuredAuction" />
        </div>
    </div>
</div>
